/* eslint react/prop-types: 0 */
import React from 'react'
import Select from 'react-select'
import { FormInput } from 'camino-react'

const ResponseTimeCondition = ({
  update,
  predicates: {
    by,
    response_timeframe: time
  }
}) => {
  const byOptions = [
    { label: 'Client', value: 'client' },
    { label: 'Calligo', value: 'calligo' }
  ]

  const timeOptions = [
    { value: '30', label: '30 minutes' },
    { value: '60', label: '1 hour' },
    { value: '90', label: '1 hour, 30 minutes' },
    { value: '120', label: '2 hours' },
    { value: '150', label: '2 hours, 30 minutes' },
    { value: '180', label: '3 hours' },
    { value: '210', label: '3 hours, 30 minutes' },
    { value: '240', label: '4 hours' },
    { value: '270', label: '4 hours, 30 minutes' },
    { value: '300', label: '5 hours' },
    { value: '330', label: '5 hours, 30 minutes' },
    { value: '360', label: '6 hours' },
    { value: '1440', label: '1 day' },
    { value: '2880', label: '2 days' },
    { value: '4230', label: '3 days' },
    { value: '5760', label: '4 days' },
    { value: '7200', label: '5 days' }
  ]

  return (
    <div>
      <FormInput label="Who">
        <Select
          options={byOptions}
          value={by}
          onChange={e => update('by', e.value)}
        />
      </FormInput>

      <FormInput label="Time">
        <Select
          options={timeOptions}
          value={time}
          onChange={e => update('response_timeframe', e.value)}
        />
      </FormInput>
    </div>
  )
}

export default ResponseTimeCondition
